module.exports = __webpack_public_path__ + "img/pic-slider-1.d43f077.webp";